import {find} from '../find/find';
import {kuiset} from '../../kuiset';

const dialogCloseUrl = () => {
    document.addEventListener('keyup', function (e) {
        const dialogEl = find('[role="dialog"]');
        const alertDialogEl = find('[role="alertdialog"]');

        if (
            (dialogEl && e.key === 'Escape') ||
            (alertDialogEl && e.key === 'Escape')
        ) {
            const {dialogCloseUrl: closedUrl} = kuiset(
                dialogEl || alertDialogEl
            );
            window.location = closedUrl;
        }
    });
};

dialogCloseUrl();

export {dialogCloseUrl};
